import { render, staticRenderFns } from "./HelpCenterLayout.vue?vue&type=template&id=53af27d1&scoped=true&"
import script from "./HelpCenterLayout.vue?vue&type=script&lang=js&"
export * from "./HelpCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterLayout.vue?vue&type=style&index=0&id=53af27d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af27d1",
  null
  
)

export default component.exports